var render, staticRenderFns
var script = {}
import style0 from "./McToastAlert.vue?vue&type=style&index=0&id=3e4cb207&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports